import React, { useEffect } from "react";
import { useSearchParams } from "react-router-dom";
import CoreServices from "../services-components/CoreServices";
import PackagesSection from "../services-components/PackagesSection";

function Services() {
  const [searchParams] = useSearchParams();
  const serviceId = searchParams.get("service");

  useEffect(() => {
    if (serviceId) {
      // Wait a moment for the DOM to be ready
      setTimeout(() => {
        const element = document.getElementById(`service-${serviceId}`);
        if (element) {
          element.scrollIntoView({ behavior: "smooth", block: "center" });
        }
      }, 100);
    }
  }, [serviceId]);

  return (
    <div>
      <CoreServices />
      <PackagesSection />
    </div>
  );
}

export default Services;
